const getNotificationAuthHeaders = () => {
  const token =
    typeof window !== "undefined"
      ? `${window.localStorage.getItem("strToken") || ""}`.trim()
      : "";

  return {
    "Content-Type": "application/json",
    Authorization: token,
    "x-access-token": token,
  };
};

export {
  getNotificationAuthHeaders,
};
